import { c as _c } from "react/compiler-runtime";
import { Button, Input } from '@common/components';
import { cn } from '@core/utils';
interface PointUsageSectionProps {
  availablePoints: number;
  usedPoints: number;
  isInsufficient?: boolean;
  isLoading?: boolean;
}
export const PointUsageSection = t0 => {
  const $ = _c(25);
  const {
    availablePoints,
    usedPoints,
    isInsufficient: t1,
    isLoading: t2
  } = t0;
  const isInsufficient = t1 === undefined ? false : t1;
  const isLoading = t2 === undefined ? false : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h2 className="font-700 text-Gray-900 typo-h6 mobile-tablet:typo-body2">웰포인트 사용</h2>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== availablePoints || $[2] !== isLoading) {
    t4 = isLoading ? "-" : availablePoints.toLocaleString();
    $[1] = availablePoints;
    $[2] = isLoading;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t4) {
    t5 = <div className="mb-4 flex h-48 items-center justify-between">{t3}<span className="text-Gray-600 typo-body2 mobile-tablet:font-600 mobile-tablet:typo-caption1">보유 : {t4}P</span></div>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== isLoading || $[7] !== usedPoints) {
    t6 = isLoading ? "-" : usedPoints.toLocaleString();
    $[6] = isLoading;
    $[7] = usedPoints;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = isInsufficient ? "border-R-400 text-R-400" : "border-O-400 text-O-400";
  let t8;
  if ($[9] !== t7) {
    t8 = cn("flex-1 !rounded-none font-500 typo-body2 mobile-tablet:typo-body4", t7);
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = isInsufficient ? "text-R-400" : "text-O-400";
  let t10;
  if ($[11] !== t9) {
    t10 = cn("font-700", t9);
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10) {
    t11 = <span className={t10}>P</span>;
    $[13] = t10;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t11 || $[16] !== t6 || $[17] !== t8) {
    t12 = <Input dimensions="H48" readOnly={true} value={t6} className={t8} rightContent={t11} />;
    $[15] = t11;
    $[16] = t6;
    $[17] = t8;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Button dimensions="H48" theme="sub-line" className="!rounded-none border-Gray-900" disabled={true}>전액 사용</Button>;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t12) {
    t14 = <div className="flex gap-8">{t12}{t13}</div>;
    $[20] = t12;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t14 || $[23] !== t5) {
    t15 = <section>{t5}{t14}</section>;
    $[22] = t14;
    $[23] = t5;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  return t15;
};